var exports = {
  "x2": "popoverContainer__GIsq5b",
  "_m": "popoverHeading__IvE6OV",
  "B5": "headingRow__WJtYAC",
  "G": "infoIcon__WfI9e6",
  "jp": "popoverText__Qn4-P9",
  "YT": "actionsRow__vmvfbz",
};

module.exports = exports;
